import React from 'react';

function RideDetailsLine({ text, value }) {
    return (
        <div className="rideDetailsLine">
            <div className="rideDetailsLine--label">
                {text}
            </div>
            <div className="rideDetailsLine--value">
                {value}
            </div>
        </div>
    );
}

export default RideDetailsLine;